import React from 'react';
import PublicPolicyPage from 'src/components/public-policy-page';

const TermsOfUse: React.FC = () => (
  <PublicPolicyPage
    title="Terms of Use"
    scriptSrc="https://app.enzuzo.com/scripts/tos/02e5dbd2-1809-11f1-897f-f394f6e7fda1"
  />
);

export default TermsOfUse;
